import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Divider, Stack, Typography } from '@mui/material'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'
import { FactsTable, FactsTableRow } from '../components/FactsTable'

export const RelatedIssues = ({ linkedIssues }) => {
    const { t } = useTranslation()

    let tableRowsIssues = []
    let tableRowsConvertibles = []

    const wrapWithLink = (entity, label) => {
        if (!entity.type) {
            return <Link to={`/convertibles/${entity.id}`}>{label}</Link>
        }
        return entity.type !== 'Guarantor fee issue' ? <Link to={`/issues/${entity.id}`}>{label}</Link> : label
    }

    const getRelatedEntities = (linkedIssues) => {
        const matchedIssues = []
        const matchedConvertibles = []
        for (let group of linkedIssues) {
            if (Array.isArray(group.issues)) {
                const issues = group.issues.filter((issue) => issue.type !== 'Guarantor fee issue')
                matchedIssues.push(...issues)
            }
            if (Array.isArray(group.convertibles)) {
                matchedConvertibles.push(...group.convertibles)
            }
        }
        return { matchedIssues, matchedConvertibles } // Return all matching issues
    }

    const { matchedIssues: relatedIssues, matchedConvertibles: relatedConvertibles } = getRelatedEntities(linkedIssues)

    if (relatedIssues.length === 0 && relatedConvertibles.length === 0) {
        return null
    }

    if (relatedIssues.length > 0) {
        {
            relatedIssues.map((issue) => {
                tableRowsIssues.push(
                    <FactsTableRow
                        key={tableRowsIssues.length}
                        label={wrapWithLink(issue, t(`entities.issueType.values.${issue.type}`))}
                    >
                        {formatDateYYYYMMDD(issue.subStartDate || issue.publicationDate)}
                    </FactsTableRow>,
                )
            })
        }
    }

    if (relatedConvertibles.length > 0) {
        relatedConvertibles.map((convertible) => {
            tableRowsConvertibles.push(
                <FactsTableRow
                    key={tableRowsConvertibles.length}
                    label={wrapWithLink(convertible, convertible.convertibleName)}
                >
                    {formatDateYYYYMMDD(convertible.subStartDate || convertible.publicationDate)}
                </FactsTableRow>,
            )
        })
    }

    const showConvertibles = relatedConvertibles.length > 0

    return (
        <Stack
            sx={{
                mb: 4,
            }}
        >
            {relatedIssues.length > 0 ? (
                <>
                    <Typography variant='subtitle2'>Relaterade emissioner</Typography>
                    <FactsTable rows={tableRowsIssues} />
                    <Divider sx={showConvertibles ? { mb: 4 } : null} />
                </>
            ) : null}
            {showConvertibles ? (
                <>
                    <Typography variant='subtitle2'>Relaterade konvertibler</Typography>
                    <FactsTable rows={tableRowsConvertibles} />
                    <Divider />
                </>
            ) : null}
        </Stack>
    )
}
